// extracted by mini-css-extract-plugin
export var active = "footer-module--active--jYN7l";
export var footer = "footer-module--footer--KzCqU";
export var footerContain = "footer-module--footerContain--0r8Xh";
export var lastLine = "footer-module--lastLine--TMB-T";
export var leftSide = "footer-module--leftSide--ZfjK8";
export var linkContain = "footer-module--linkContain--kP0PG";
export var linksWebsites = "footer-module--linksWebsites--aednf";
export var rightSide = "footer-module--rightSide--KkyPd";
export var titlePink = "footer-module--titlePink--sEY+G";
export var titleWhite = "footer-module--titleWhite--e8ya9";